
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { MasterPlansRepository } from "../../repositories";
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeleteMasterPlanUsecase implements UseCase<string, boolean> {

  constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }

  execute(params: string): Observable<boolean> {
    return this.masterPlanRepository.deleteMasterPlan(params);
  }

}